<template>
  <div>
    <h6 class="text-subtitle-1 text-md-h6 font-weight-bold mb-4">Factura cargada</h6>
    <v-card elevation="1" class="pa-4">
      <v-container fluid class="pa-0">
        <v-row class="d-flex align-center row-gutter-16 flex-nowrap">
          <v-col cols="auto" class="flex-grow-0 flex-shrink-0">
            <v-icon
              style="background-color: #d32f2f"
              class="rounded-lg pa-2"
              color="white"
              >description</v-icon
            >
          </v-col>
          <v-col class="flex-grow-1 invoice-name-col">
            <span
              class="blue--text text--darken-2 font-weight-medium text-subtitle-1 text-md-h6 short-text"
              @click="openPDFInNewTab(invoice)"
              >{{ invoice.name }}</span
            >
          </v-col>
          <v-col cols="auto" class="flex-grow-0 flex-shrink-0" v-if="canRemove">
            <v-btn :disabled="disableDeleteButton" @click="removeFile" icon
              ><v-icon>delete_outline</v-icon></v-btn
            >
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "UploadedInvoice",
  props: {
    invoice: {
      type: File,
      required: true,
    },
    canRemove: {
      type: Boolean,
      default: false,
    },
    disableDeleteButton: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    removeFile() {
      this.$store.dispatch("invoice/setInvoiceFile", null);
    },
    openPDFInNewTab(invoice) {
      if (invoice) {
        const blobUrl = URL.createObjectURL(invoice);
        window.open(blobUrl, "_blank");
      }
    },
  },
};
</script>

<style scoped>
.invoice-name-col {
  min-width: 0;
  max-width: 100%;
}
.short-text {
  display: block;
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
}
.row-gutter-16 {
  margin: -8px;
}
.row-gutter-16 > .col,
.row-gutter-16 > [class*="col-"] {
  padding: 8px;
}
</style>
